<template>
  <div class="pg-coach-layout">
    <div class="pg-coach-layout__content">
      <div class="content__page">
        <component
          v-if="subLayoutData"
          :is="getSubLayoutComponent"
          :layoutProps="getSubLayoutProps"
          :subLayoutData="getChildLayoutData"
        >
          <slot></slot>
        </component>
        <slot v-else></slot>
      </div>
    </div>
    <MessageWidget />
    <LoadingOverlay v-if="pageLoading" />
  </div>
</template>

<script>
import MessageWidget from "@/components/message_widget/MessageWidget.vue"
import LoadingOverlay from "@/components/overlays/LoadingOverlay"
import BlankLayout from "@/layouts/BlankLayout.vue"
import { mapGetters } from "vuex"

export default {
  components: {
    MessageWidget,
    LoadingOverlay,
  },
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("Util", ["pageLoading"]),
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";

.pg-coach-layout {
  background-color: $gray;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.pg-coach-layout__content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
}

.content__page {
  flex: 1 1 auto;
}
</style>



// WEBPACK FOOTER //
// src/layouts/CoachLayout.vue